'use strict';

var chunkA6GZ26F6_js = require('../chunk-A6GZ26F6.js');
require('../chunk-JOML6I2W.js');



Object.defineProperty(exports, 'CN_DATETIME_UNITS', {
	enumerable: true,
	get: function () { return chunkA6GZ26F6_js.a; }
});
Object.defineProperty(exports, 'CN_MONTH_NAMES', {
	enumerable: true,
	get: function () { return chunkA6GZ26F6_js.d; }
});
Object.defineProperty(exports, 'CN_NUMBER_BIG_DIGITS', {
	enumerable: true,
	get: function () { return chunkA6GZ26F6_js.h; }
});
Object.defineProperty(exports, 'CN_NUMBER_BIG_UNITS', {
	enumerable: true,
	get: function () { return chunkA6GZ26F6_js.i; }
});
Object.defineProperty(exports, 'CN_NUMBER_DIGITS', {
	enumerable: true,
	get: function () { return chunkA6GZ26F6_js.f; }
});
Object.defineProperty(exports, 'CN_NUMBER_UNITS', {
	enumerable: true,
	get: function () { return chunkA6GZ26F6_js.g; }
});
Object.defineProperty(exports, 'CN_SHORT_MONTH_NAMES', {
	enumerable: true,
	get: function () { return chunkA6GZ26F6_js.e; }
});
Object.defineProperty(exports, 'CN_SHORT_WEEK_DAYS', {
	enumerable: true,
	get: function () { return chunkA6GZ26F6_js.c; }
});
Object.defineProperty(exports, 'CN_WEEK_DAYS', {
	enumerable: true,
	get: function () { return chunkA6GZ26F6_js.b; }
});
